export const BLANK_STATUS: { label: string; value: BlankStatusType }[] = [
  { label: 'BATCH_MAILING.BLANKS_TAB.STATUS_NEW', value: 'new' },
  {
    label: 'BATCH_MAILING.BLANKS_TAB.STATUS_PROCESSING',
    value: 'processing',
  },
  { label: 'BATCH_MAILING.BLANKS_TAB.STATUS_DONE', value: 'done' },
  { label: 'BATCH_MAILING.BLANKS_TAB.STATUS_ERROR', value: 'error' },
];

export const BLANK_STATUS_FILTERS: {
  label: string;
  value: BlankStatusType;
}[] = [
  {
    label: 'BATCH_MAILING.BLANKS_TAB.STATUS_PROCESSING',
    value: 'processing',
  },
  { label: 'BATCH_MAILING.BLANKS_TAB.STATUS_DONE', value: 'done' },
];

export type BlankStatusType = 'new' | 'processing' | 'done' | 'error';

export const BLANK_STATUS_MAP = new Map<BlankStatusType, string>(
  BLANK_STATUS.map<[BlankStatusType, string]>((item) => [
    item.value,
    item.label,
  ])
);
